import * as RouteNames from "@/employee/route-names";
import { InvestmentCustodian } from "@/shared/types";

export const footerTemplate = "UcbFooter";

export const investmentRiskDisclaimer = null;

export const profileEditInformationHtml = "Please login to your UCB online account, or call 1-866-719-6039 to make updates to locked information.";

export const displayMyProfileEditMode = false;

export const logoutRedirectUrl = null;

export const faqTemplate = "UcbForms";

export const faqInstructionsTemplate = "";

export const faqLinkAddress = "";

export const displayFaqInstructions = false;

export const displayAdvice = false;

export const displayFaqExternalLinks = true;

export const displayInvestmentsSection = false;

export const displaySettingsLinkedAccounts = false;

export const allowEmailEdit = true;

export const priorYearContributionOption = true;

export const allowReimbursement = false;

export const showPendingReimbursements = false;

export const showAlternateOnboardingCompleteMessage = true;

export const disabledRouteRedirects = {
  [RouteNames.Contribution]: RouteNames.CashBalance,
  [RouteNames.ContributionsEdit]: RouteNames.CashBalance,
  [RouteNames.ManagePayrollContributions]: RouteNames.CashBalance,
  [RouteNames.ContributionsManageOtherHsaAmounts]: RouteNames.CashBalance,
  [RouteNames.ConfirmContribution]: RouteNames.CashBalance
};

export const displayCashAccountMfaPopup = true;

export const feeTemplate = "TermsFeeSchedule";

export const quarterlyPaperStatementFee = 1.5;

export const manageHsaCardsInPortal = false;

export const displayPriorYearContributionDisclaimerCopy = false;

export const displayProjectedContributions = false;

export const allowUserToEditContributions = true;

export const showCashExpensesGraphWidget = false;
export const showExpenseCategoryWidget = false;
export const showExpenseEligibilityWidget = false;
export const showHealthcareExpensesV2 = false;
export const showHsaStoreShopTab = true;

export const displayPdfForESign = false;

export const displayHealthcareBluebookLink = true;

export const displayFooterLegalSection = false;

export const contactDetailsSetAtBank = false;

export const displayHealthcareClaims = true;
export const displayNewHealthcareExpenses = false;